import React from "react"
import CreateUserFromInvitationForm from "./create-user-from-invitation-form"

export default function SignUpPage(): React.JSX.Element {
  return <CreateUserFromInvitationForm />
}
